<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-beautify`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M23.98 2h.119c.115 0 .23.002.344.004l.003.001h.012C36.397 2.248 46 12.003 46 24c0 12.15-9.85 22-22 22S2 36.15 2 24c0-.342.008-.682.023-1.02L2 22.979C2.517 11.66 11.587 2.572 22.899 2.026l.098-.005c.169-.007.338-.013.508-.016l.104-.002h.072l-.176.002c.157-.003.314-.005.472-.005h.004zm-.005 5.581c-2.502 7.993-9.442 14.024-17.934 15.207-.027.4-.041.804-.041 1.212 0 9.941 8.059 18 18 18s18-8.059 18-18c0-.405-.013-.807-.04-1.206-8.515-1.166-15.478-7.204-17.985-15.213zM20 29a3 3 0 10-6 0 3 3 0 006 0zm11-3a3 3 0 110 6 3 3 0 010-6zM27.799 6.408a18.034 18.034 0 0013.35 12.184 18.034 18.034 0 00-13.35-12.184zm-7.65.006l-.01.001c-6.316 1.38-11.39 6.076-13.31 12.171l-.027.006.026-.005A18.034 18.034 0 0020.15 6.413zm3.204-4.405l.09-.003c-.136.004-.272.008-.408.014l-.038.001h.026l.012-.001.15-.005.169-.006z"/></svg>
</template>
<script>

export default {
  name: 'IconBeautify',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
